import { useCallback } from 'react';
import { CanvasItemPlacer } from '../../utils/canvasItemPlacer';

const useDirectCanvasPlacement = ({
  droppedItems,
  setDroppedItems,
  setSelectedItem,
  placeholderWidth,
  placeholderHeight
}) => {
  
  const handleCardClick = useCallback(async (item, e) => {
    try {
      // Prevent any default behavior
      e.preventDefault();
      e.stopPropagation();
      
      console.log('🔍 Card clicked for direct placement:', item.clothesName || item.id);
      
      // Check if item is already on canvas
      const existingItemIndex = droppedItems.findIndex(droppedItem => droppedItem.id === item.id);
      
      if (existingItemIndex !== -1) {
        // Item already exists, just select it
        console.log('✅ Item already on canvas, selecting it');
        setSelectedItem(existingItemIndex);
        return;
      }
      
      // Add new item to canvas center with smart positioning and proper aspect ratio
      const newItem = await CanvasItemPlacer.addItemWithSmartPositioning(
        item, 
        droppedItems, 
        placeholderWidth, 
        placeholderHeight
      );
      
      // Add item to canvas
      const newItems = [...droppedItems, newItem];
      setDroppedItems(newItems, 'add-item');
      
      // Don't auto-select the item - this prevents the "sticky mouse" behavior
      // where the item follows the cursor after being added
      // User can click on the item to select it if needed
      
    } catch (error) {
      console.error('Error adding item to canvas:', error);
    }
  }, [droppedItems, setDroppedItems, setSelectedItem, placeholderWidth, placeholderHeight]);

  const handleCardClickWithFeedback = useCallback(async (item, e) => {
    // Add visual feedback during placement
    const cardElement = e.currentTarget;
    
    // Add loading state
    cardElement.style.opacity = '0.7';
    cardElement.style.transform = 'scale(0.95)';
    
    try {
      await handleCardClick(item, e);
      
      // Success feedback
      cardElement.style.opacity = '1';
      cardElement.style.transform = 'scale(1)';
      cardElement.style.transition = 'all 0.2s ease';
      
      // Brief highlight effect
      setTimeout(() => {
        cardElement.style.boxShadow = '0 0 20px rgba(0, 181, 173, 0.5)';
        setTimeout(() => {
          cardElement.style.boxShadow = '';
          cardElement.style.transition = '';
        }, 300);
      }, 100);
      
    } catch (error) {
      // Error feedback
      cardElement.style.opacity = '1';
      cardElement.style.transform = 'scale(1)';
      cardElement.style.boxShadow = '0 0 20px rgba(220, 53, 69, 0.5)';
      
      setTimeout(() => {
        cardElement.style.boxShadow = '';
      }, 500);
    }
  }, [handleCardClick]);

  return {
    handleCardClick: handleCardClickWithFeedback,
    handleDirectPlacement: handleCardClick
  };
};

export default useDirectCanvasPlacement;